import AccountCardEmptyTextFormModal, {
  ACCOUNT_CARD_EMPTY_TEXT_FORM_MODAL,
} from './AccountCardEmptyTextFormModal';

export { ACCOUNT_CARD_EMPTY_TEXT_FORM_MODAL };

export default AccountCardEmptyTextFormModal;
